import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const customersPaths = {
	default: '',
	root: 'customers',
	list: 'list',
	detail: ':id',
};

export const customersFragments = {
	default: [customersPaths.default],
	root: [customersPaths.default, customersPaths.root],
	list: [customersPaths.default, customersPaths.root, customersPaths.list],
	detail: (id: number) => [customersPaths.default, customersPaths.root, id],
};

export const customersDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const customersDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: {
		roles: customersDefaultAuthRoles,
	},
};
